<ng-container [ngSwitch]="remoteServiceStore.remoteServiceDiagnosisLoadingStatus$ | async">
  <ng-container *ngSwitchCase="RemoteServiceDiagnosisLoadingStatus.DataLoading">
    <ng-container *ngTemplateOutlet="dataLoading"></ng-container>
  </ng-container>
  <ng-container
    *ngIf="
      deviceStore.isLegacyDeviceWithoutBoilerSerial$ | async;
      else isNotLegacyOrHasBoilerSerialDevice
    "
  >
    <app-banner type="info">{{
      '+REMOTE_SERVICE.LEGACY_DEVICE_MISSING_SERIAL' | translate
    }}</app-banner>
  </ng-container>
  <ng-template #isNotLegacyOrHasBoilerSerialDevice>
    <ng-container *ngSwitchCase="RemoteServiceDiagnosisLoadingStatus.DataPresent">
      <ng-container *ngTemplateOutlet="dataGrid"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="RemoteServiceDiagnosisLoadingStatus.ServiceNotAvailable">
      <ng-container *ngTemplateOutlet="noData"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="RemoteServiceDiagnosisLoadingStatus.EmptySuccessData">
      <ng-container *ngTemplateOutlet="noData"></ng-container>
    </ng-container>
  </ng-template>
</ng-container>

<ng-template #dataLoading>
  <vi-loader
    body
    [isLoading]="true"
    message="{{ '+REMOTE_SERVICE.LOADING_DATA' | translate }}"
  ></vi-loader>
</ng-template>
<ng-template #noData>
  <app-banner type="info">{{
    diagnosisCalculationDataStatus ===
    RemoteServiceDiagnosisLoadingStatus.DiagnosisCalculationsNotReadyYet
      ? ('+REMOTE_SERVICE.DIAGNOSIS_NO_ENOUGH_DATA' | translate)
      : ('+REMOTE_SERVICE.DIAGNOSIS_NO_DATA' | translate)
  }}</app-banner>
</ng-template>

<ng-template #dataGrid>
  <div
    class="content-wrapper"
    *ngIf="remoteServiceStore.annualReportState$ | async as annualReportState"
  >
    <app-feature-list-container *appShowForRsaUser>
      <span class="report-wrapper">
        <span class="report-title">{{ '+REMOTE_SERVICE.DETAILED_REPORT_TITLE' | translate }}</span>
        <span class="report-content">
          <span class="report-description">{{
            '+REMOTE_SERVICE.DETAILED_REPORT_DESCRIPTION' | translate
          }}</span>
          <div>
            <button
              data-at-download-annomaly-button
              mat-stroked-button
              gtm="onDownload"
              gtmAction="Download service anomaly summary report"
              gtmCategory="remoteService"
              color="primary"
              class="report-generate-btn"
              [disabled]="annualReportState.loading"
              (click)="onDownloadServiceReportAnomalySummaryClicked()"
            >
              <mat-spinner
                *ngIf="
                  annualReportState.reportTemplate === remoteServiceReportTemplate &&
                    annualReportState.loading;
                  else icon
                "
              ></mat-spinner>
              {{ '+REMOTE_SERVICE.REPORT_GENERATE_BTN' | translate }}
            </button>
          </div>
        </span>
      </span>
    </app-feature-list-container>

    <app-feature-list-container
      *ngIf="
        (installationDetailsStore.isMaintainerAssigned$ | async) || (authStore.isRsaUser() | async)
      "
    >
      <span class="report-wrapper">
        <span class="report-title">{{ '+REMOTE_SERVICE.PRO_REPORT_TITLE' | translate }}</span>
        <span class="report-content">
          <span class="report-description">{{
            '+REMOTE_SERVICE.PRO_REPORT_DESCRIPTION' | translate
          }}</span>
          <div>
            <button
              data-at-download-maintainer-annomaly-button
              mat-stroked-button
              gtm="onDownload"
              gtmAction="Download yearly anomaly summary report"
              gtmCategory="remoteService"
              color="primary"
              class="report-generate-btn"
              [disabled]="annualReportState.loading"
              (click)="onDownloadYearlyReportAnomalySummaryClicked()"
            >
              <mat-spinner
                *ngIf="
                  annualReportState.reportTemplate === yearlyReportTemplate &&
                    annualReportState.loading;
                  else icon
                "
              ></mat-spinner>
              {{ '+REMOTE_SERVICE.REPORT_GENERATE_BTN' | translate }}
            </button>
          </div>
        </span>
      </span>
    </app-feature-list-container>
  </div>
</ng-template>
<ng-template #icon>
  <mat-icon>cloud_download</mat-icon>
</ng-template>
